import { render } from "./employees-list.vue?vue&type=template&id=ffba7a62"
import script from "./employees-list.vue?vue&type=script&lang=js"
export * from "./employees-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__